
import { defineComponent, SetupContext, computed } from "vue";
import NativeClient from "@/client/native-client";
import { FoodTipData } from "@/types/pantry";

export default defineComponent({
  name: "PantryFoodTipTitle",
  components: {
  },
  props: {
    data: {
      type: FoodTipData,
      default: null
    },
    selectId: {
      type: Number,
      default: 0,
      require: true
    }
  },
  setup(props, context: SetupContext) {
    const getTitle = () => {
      let result = "";
      if (props.data && props.data.title) {
        result = props.data.title;
      }
      return result;
    };
    const onClickTitle = () => {
      const id = (props.data) ? props.data.id : -1;
      if (id != -1) {
        context.emit("select-tip", props.data.id);
      }
    };
    const isActive = () => {
      return (props.data && props.data.id == props.selectId);
    };
    const styleText = () => {
      return isActive() ? "bold" : "normal";
    };
    return {
      getTitle,
      isActive,
      styleText,
      onClickTitle
    };
  }
});
